export default "__VITE_ASSET__CY0225Fp__"